module.exports = __webpack_public_path__ + "a83ab83a3d43222e4ba77cf96e0074aa.xap"


/*****************
 ** WEBPACK FOOTER
 ** ./~/mediaelement/build/silverlightmediaelement.xap
 ** module id = 1252
 ** module chunks = 0
 **/